import { subscribeToPushes } from "@app/features/subscribe-push/lib/SubscribeToPushes.tsx";
import { Text } from "@mantine/core";
import { openConfirmModal } from "@mantine/modals";
import i18next from "i18next";
import * as React from "react";

/**
 * Открывает модальное окно с уведомлением, что игра хочет получить разрешение на отправку пушей
 * @param params Параметры модалки
 */
export function openPushPermissionModal(params: {
	onPushSubscriptionSuccess: (subscription: PushSubscription) => void;
	onPushSubscriptionFail: () => void;
	serverKey: string;
	gameName: string;
}) {
	const title = i18next.t("push_permission_modal.title");
	const message = i18next.t("push_permission_modal.message", { game: params.gameName });
	const cancelLabel = i18next.t("button_cancel");
	const confirmLabel = i18next.t("button_ok");

	return openConfirmModal({
		modalId: "push-permission",
		size: "sm",
		title: title,
		children: <Text>{message}</Text>,
		labels: { cancel: cancelLabel, confirm: confirmLabel },
		onConfirm: () => {
			subscribeToPushes(params.serverKey)
				.then((subscription) => {
					if (subscription) return params.onPushSubscriptionSuccess(subscription);
					params.onPushSubscriptionFail();
				})

				.catch((e) => log.error("[PUSH] Unhandled error while subscribing to push notifications", e));
		}
	});
}
